"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var TICK_MARGIN_TOP = 16;
function BarTickTwoLine(_a) {
    var data = _a.data, x = _a.x, y = _a.y, formatter = _a.formatter;
    var _b = formatter ? formatter(data) : prepareDisplayValueForTwoLineTick(data), title = _b.title, subtitle = _b.subtitle;
    return (react_1.default.createElement("g", { transform: "translate(".concat(x, ", ").concat(y + TICK_MARGIN_TOP, ")") },
        react_1.default.createElement(kaleidoscope_1.Label, { className: "chart__tick-label", element: "text" }, title),
        react_1.default.createElement(kaleidoscope_1.Text, { className: "chart-custom__subtitle chart__tick-number", element: "text" }, subtitle)));
}
function prepareDisplayValueForTwoLineTick(barData) {
    return {
        title: barData.xAxisName,
        subtitle: barData.data.reduce(function (acc, next) { return acc + next; }, 0),
    };
}
exports.default = BarTickTwoLine;
